"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = (theme) => ({
    dialogPaper: {
        overflowY: 'visible',
    },
    preferencesText: {
        fontSize: theme.mixins.register.fontSize.default,
    },
    buttonArea: {
        padding: 10,
        paddingTop: 0,
    },
    linkButton: {
        width: 'fit-content',
        textAlign: 'left',
        justifyContent: 'left',
        textTransform: 'initial',
        '&:focus, &:focus-visible, &:active, &:hover': {
            background: 'transparent',
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
    },
    linkText: {
        verticalAlign: 'inherit',
        marginLeft: 4,
        textDecoration: 'underline',
        color: theme.palette.link.interactive,
    },
});
exports.styles = styles;
